import { Alert, Grid, styled, Typography } from '@mui/material';
import { usePostHog } from '@posthog/react';
import { useEffect } from 'react';
import { isRouteErrorResponse, useRouteError } from 'react-router';
import { Button } from '~/components/Button';
import Image from '~/components/Image';
import { PageTemplate } from '~/components/PageTemplate';
import { useUser } from '~/hooks/useUser';
export function ErrorBoundary() {
  const error = useRouteError();
  const errorResponse = isRouteErrorResponse(error) ? error : undefined;
  const genericError = error instanceof Error ? error : undefined;

  const user = useUser();
  const details =
    errorResponse?.data ||
    genericError?.message ||
    'Please try again or email support@nerdydata.com for assistance.';
  const stack = import.meta.env.DEV ? genericError?.stack : undefined;
  const posthog = usePostHog();

  // const [searchParams] = useSearchParams();
  useEffect(() => {
    if (error instanceof Error === false) {
      return;
    }
    if (window.FS) {
      window.FS('trackEvent', {
        name: 'error',
        message: details,
        error: error,
      });
    }
    posthog?.captureException(error);
  }, [error, user?.uuid, details, posthog]);

  return (
    <PageTemplate breadcrumbs={[{ href: '/', text: 'Home' }]}>
      <Grid container spacing={2} justifyContent={'center'}>
        <Grid item xs={12} md={10} lg={8} textAlign={'center'}>
          <Typography variant="h4">
            We’re sorry, something went wrong.
          </Typography>
          <Alert severity="warning" sx={{ my: 2 }}>
            {details}
          </Alert>
          <Button href="/reports/new" variant="contained" sx={{ mt: 2 }}>
            New Search
          </Button>
          <Typography variant="body1" mt={3}>
            We're here if you ever need help.
            <br />
            Email us at{' '}
            <a href="mailto:support@nerdydata.com">support@nerdydata.com</a>.
          </Typography>
        </Grid>
      </Grid>
      {stack && (
        <Grid container spacing={2} justifyContent={'center'}>
          <Grid item xs={12} textAlign={'center'}>
            <Typography variant="body1" mt={3} textAlign={'left'}>
              <pre>{stack}</pre>
            </Typography>
          </Grid>
        </Grid>
      )}
      <Grid container spacing={2} justifyContent={'center'} mt={6}>
        <Grid
          item
          xs={12}
          md={6}
          lg={6}
          justifyContent={'center'}
          textAlign={'center'}>
          <StyledImage
            src={`${
              import.meta.env.VITE_STATIC_ASSETS_URL
            }/img/undraw_questions_75e0.svg`}
          />
        </Grid>
      </Grid>
    </PageTemplate>
  );
}

const StyledImage = styled(Image)`
  width: 300px;
  margin: auto;
`;
